// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer_Xmle1","logoButton":"Footer_logoButton_PAih8","text":"Footer_text_gGr7v"};